import { Esito } from 'lib/api/sport/sportScommesseBySlugResponse';
import { ItemWithTranslation } from 'types/swagger';
import { ScommesseTableSubtitle } from 'components/scommesseTable/scommesseTableSubtitle';
import { SportTicketInfo } from 'features/sport/types';
import classNames from 'classnames';
import { isNotEmpty, isTruthy } from 'utility/functions';
import styles from './ScommesseListing.module.scss';
import { useIsAtLeastOneActive } from 'features/sport/hooks';

export type ScommesseListingProps = {
  title?: string;
  list: Array<{
    infoAggiuntiva: string;
    scommesse: Array<Esito & { header?: string }>;
    isBalanced?: boolean;
  }>;
  infoTicket?: SportTicketInfo;
};

const ScommesseListing = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

interface RowProps extends ItemWithTranslation<{ header?: string }> {
  infoAggiuntivaKey?: string;
  infoAggiuntiva?: string;
  isBalanced: boolean;
  children: React.ReactNode;
  showHeader?: boolean;
}

const Row = ({
  infoAggiuntiva,
  isBalanced,
  children,
  header,
  headerTrKey,
  infoAggiuntivaKey,
  showHeader,
}: RowProps) => {
  const isActive = useIsAtLeastOneActive([infoAggiuntivaKey ?? ''], true);

  return (
    <div
      data-testid={`listing-row-${infoAggiuntiva}`}
      className={classNames(styles.list, { [styles.hidden]: !isActive })}
      key={infoAggiuntiva}
      suppressHydrationWarning
    >
      <div className={styles.container}>
        {isTruthy(showHeader) && isNotEmpty(header) && (
          <ScommesseTableSubtitle header={header} headerTrKey={headerTrKey} />
        )}
        <div className={styles.textWrapper} suppressHydrationWarning>
          <p className={styles.paragraph} suppressHydrationWarning>
            {isBalanced && <span className={styles.balanced} suppressHydrationWarning></span>}
            <span className={styles.label} suppressHydrationWarning>
              {infoAggiuntiva}
            </span>
          </p>
        </div>
      </div>
      {children}
    </div>
  );
};

ScommesseListing.Row = Row;

export { ScommesseListing };
